import { __rest } from "tslib";
import * as React from 'react';
const ChevronRightLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", fill: "currentColor", width: size || "32", height: size || "32" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M11.7071068,6 L20.995,15.297 L20.9987495,15.2942131 L21.7058563,16.0013199 L21.702,16.004 L21.7047279,16.0079735 L20.9976211,16.7150802 L20.994,16.712 L11.7071068,26.0026397 L11,25.295533 L20.287,16.005 L11,6.70710678 L11.7071068,6 Z" })));
};
ChevronRightLarge.displayName = 'ChevronRightLarge';
export default ChevronRightLarge;
//# sourceMappingURL=ChevronRightLarge.js.map